import { useEffect, useState } from 'react';
import useHttp from '../../../../hooks/use-http';
import OInput from '../../../UI/FormControls/OInput';
import { urls } from '../api/urls';
import { formatDateBody } from '../../../../../utils/FormatDate';
import OAutocomplete from '../../../UI/MuiAutocomplete';
import TextArea from '../../../UI/FormControls/TextArea';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import CheckBox from '../../../UI/FormControls/CheckBox';
// import TextArea from '../../../UI/FormControls/TextArea';

const Inputs = ({ formValues, setFormValues, servisniZahtevValues }) => {
  const { sendRequest: getSledeciBroj, data: sledeciBroj } = useHttp('');
  const { sendRequest: vratiKupce, data: kupciData } = useHttp('');
  const { sendRequest: vratiMasine, data: masineData } = useHttp('');
  const { getData } = useHttp('');
  const [expandedData, setExpandedData] = useState({
    problem: false,
    opsi: false,
    napomena: false,
  });
  const [comboPodProjekat, setComboPodProjekat] = useState([]);

  useEffect(() => {
    console.log(servisniZahtevValues);
    if (
      formValues.opisProblema === '' ||
      formValues.opisProblema === null ||
      formValues.opisProblema === undefined
    ) {
      setFormValues((curr) => {
        return { ...curr, opisProblema: servisniZahtevValues.opisProblema };
      });
    }
  }, [servisniZahtevValues]);

  const { t, i18n } = useTranslation();
  useEffect(() => {
    getSledeciBroj({ url: urls.GET_SLEDECI_BROJ });
    vratiKupce({ url: urls.GET_KUPCE_DATA });
    console.log(formValues);
  }, []);
  const getPodprojekat = async () => {
    const config = {
      method: 'POST',
      url: 'Combo/vrati_pod_projekte_za_masinu',
      data: {
        idMasine: formValues.idMasine,
      },
    };

    const response = await getData(config);
    if (response.length > 0) {
      setComboPodProjekat(response);
    } else {
      setComboPodProjekat([]);
    }
  };

  useEffect(() => {
    const config = {
      method: 'POST',
      url: urls.GET_MASINE_ZA_KUPCA,
      data: {
        id: formValues.idKupca,
        idKorProm: +localStorage.idKorisnika,
      },
    };
    vratiMasine(config);
  }, [formValues.idKupca]);

  const handleChange = (item) => {
    console.log(typeof formValues[item.target.name]);
    if (typeof formValues[item.target.name] === 'boolean') {
      setFormValues((curr) => {
        return { ...curr, [item.target.name]: item.target.checked };
      });
    } else {
      setFormValues((curr) => {
        return { ...curr, [item.target.name]: item.target.value };
      });
    }
  };
  const handleClickKupci = (item) => {
    setFormValues((curr) => {
      return {
        ...curr,
        idKupca: item.id,
        nazivKupca: item.vrednost,
        idMasine: null,
        nazivMasine: '',
        nazivPodProjekta: '',
        idPodProjekta: null,
      };
    });
  };
  const handleClickMasina = (item) => {
    setFormValues((curr) => {
      return {
        ...curr,
        idMasine: item.id,
        nazivMasine: item.vrednost,
      };
    });
    setFormValues((curr) => {
      return {
        ...curr,
        nazivPodProjekta: '',
        idPodProjekta: null,
      };
    });
  };
  const handleClickPodProjekat = (item) => {
    setFormValues((curr) => {
      return {
        ...curr,
        idPodProjekta: item.id,
        nazivPodProjekta: item.vrednost,
      };
    });
  };
  useEffect(() => {
    if (formValues.idMasine || formValues.idOridMasinegJed === 0) {
      getPodprojekat();
    } else {
      setComboPodProjekat([]);
    }
  }, [formValues.idMasine]);
  const handleChangeExpandedProblem = () => {
    setExpandedData((curr) => {
      return { ...curr, problem: !curr.problem };
    });
  };
  const handleChangeExpandedOpis = () => {
    setExpandedData((curr) => {
      return { ...curr, opis: !curr.opis };
    });
  };
  const handleChangeExpandedNapomena = () => {
    setExpandedData((curr) => {
      return { ...curr, napomena: !curr.napomena };
    });
  };

  return (
    <>
      <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
        <OInput
          label="Broj naloga"
          name="sifra"
          value={
            formValues.ceoBrDok === ''
              ? sledeciBroj.slBrDok
              : formValues.ceoBrDok
          }
          style={{ width: '100px', minWidth: '80px' }}
          disabled
        />
        <OInput
          label="Broj zahteva"
          name="sifra"
          value={servisniZahtevValues.ceoBrDok}
          style={{ width: '100px', minWidth: '80px' }}
          disabled
        />
        <OInput
          disabled
          label="Naziv zahteva"
          name="opisRadova"
          value={servisniZahtevValues.naslov}
          handleChange={handleChange}
          style={{ width: '400px', minWidth: '200px' }}
        />
        <OInput
          disabled
          label="Status robot/alat"
          name="opisRadova"
          value={servisniZahtevValues.statusMasine}
          handleChange={handleChange}
          style={{ width: '150px', minWidth: '200px' }}
        />
        <OInput
          label="Datum radnog naloga"
          style={{ width: '200px', minWidth: '150px' }}
          handleChange={handleChange}
          type="date"
          value={formatDateBody(formValues.datum)}
          name="datum"
        />
        <OAutocomplete
          data={kupciData}
          value={formValues.nazivKupca}
          handleClick={handleClickKupci}
          label="Kupac"
          style={{ width: '200px', minWidth: '150px' }}
        />
        <OAutocomplete
          data={masineData}
          value={formValues.nazivMasine}
          handleClick={handleClickMasina}
          label="Robot/Alat"
          style={{ width: '250px', minWidth: '150px' }}
        />
        <OAutocomplete
          data={comboPodProjekat}
          value={formValues.nazivPodProjekta}
          handleClick={handleClickPodProjekat}
          label={`${t('subProject')}`}
          style={{ width: '210px', minWidth: '150px' }}
        />
        <CheckBox
          style={{ height: '70px' }}
          label={`${t('completed')}`}
          handleChange={handleChange}
          checked={formValues.zavrsen}
          name="zavrsen"
        />
        <CheckBox
          style={{ height: '70px' }}
          label="Naplaćuje se"
          handleChange={handleChange}
          checked={formValues.naplacujeSe}
          name="naplacujeSe"
        />{' '}
        <CheckBox
          style={{ height: '70px' }}
          label={`${t('teren')}`}
          handleChange={handleChange}
          checked={formValues.teren}
          name="teren"
        />{' '}
        {/* <OInput
        disabled
        label="Opis problema"
        name="opisRadova"
        value={servisniZahtevValues.opisProblema}
        handleChange={handleChange}
        style={{ width: '300px', minWidth: '200px' }}
      /> */}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingRight: '10px',
        }}
      >
        <Accordion
          expanded={expandedData.problem}
          onChange={handleChangeExpandedProblem}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <strong>Opis problema</strong>
          </AccordionSummary>
          <AccordionDetails>
            <TextArea
              // disabled
              // label="Opis problema"
              rows="8"
              name="opisProblema"
              value={formValues.opisProblema}
              handleChange={handleChange}
              style={{ width: '100%', height: '150px' }}
            />
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expandedData.opis}
          onChange={handleChangeExpandedOpis}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <strong>Opis radova</strong>
          </AccordionSummary>
          <AccordionDetails>
            <TextArea
              // label="Opis radova"
              rows="8"
              name="opisRadova"
              value={formValues.opisRadova}
              handleChange={handleChange}
              style={{ width: '100%', height: '150px' }}
            />
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expandedData.napomena}
          onChange={handleChangeExpandedNapomena}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <strong>Napomena</strong>
          </AccordionSummary>
          <AccordionDetails>
            <TextArea
              // label="Napomena"
              rows="8"
              name="napomena"
              value={formValues.napomena}
              handleChange={handleChange}
              style={{ width: '100%', height: '150px' }}
            />
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};

export default Inputs;
